// MINDSTATE recommendations — progress bar logic + badge utility.
// Scroll + snap handled natively via CSS scroll-snap-type.
// NOTE: Reco cards are currently Liquid-rendered. getBadgeForProduct is a
// utility for any future JS-built card flow that fetches products via JSON API.

/**
 * Returns badge {label, type} for a product object from Shopify JSON API.
 * Hierarchy: ostatnie-sztuki > back-in-stock > new > sale (compare_at_price).
 * Returns null if no badge applies.
 */
function getBadgeForProduct(product) {
  const tags = product.tags ? product.tags.split(', ') : [];
  if (tags.includes('ostatnie-sztuki')) {
    return { label: 'Ostatnie sztuki', type: 'last' };
  }
  if (tags.includes('back-in-stock')) {
    return { label: 'Back in stock', type: 'back' };
  }
  if (tags.includes('new')) {
    return { label: 'Nowość', type: 'new' };
  }
  const compareAt = product.compare_at_price || product.variants?.[0]?.compare_at_price;
  const price = product.price || product.variants?.[0]?.price;
  if (compareAt && price && compareAt > price) {
    const pct = Math.round((compareAt - price) / compareAt * 100);
    return { label: '-' + pct + '%', type: 'sale' };
  }
  return null;
}
(function () {
  const init = (root) => {
    const track = root.querySelector('[data-ms-reco-track]');
    const thumb = root.querySelector('[data-ms-reco-progress-thumb]');
    if (!track || !thumb) return;

    const update = () => {
      const maxScroll = track.scrollWidth - track.clientWidth;
      if (maxScroll <= 0) {
        thumb.style.width = '100%';
        thumb.style.transform = 'translateX(0)';
        return;
      }
      const ratio = track.scrollLeft / maxScroll;
      const thumbWidthPct = (track.clientWidth / track.scrollWidth) * 100;
      thumb.style.width = thumbWidthPct + '%';
      const thumbX = ratio * (100 - thumbWidthPct);
      thumb.style.transform = 'translateX(' + (thumbX / Math.max(thumbWidthPct, 0.01)) * 100 + '%)';
    };

    let raf = null;
    track.addEventListener('scroll', () => {
      if (raf) return;
      raf = requestAnimationFrame(() => { update(); raf = null; });
    }, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  };

  const start = () => document.querySelectorAll('[data-ms-reco]').forEach(init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* ===================================================================
 * MS Recommendations Hydration (PROMPT 19B)
 *
 * Personalizacja last-viewed dla hamburger "WYBRANE" + cart drawer
 * "POLECANE PRODUKTY". Po DOMContentLoaded podmienia SSR-renderowane
 * bestsellery na ostatnio oglądane produkty z localStorage.
 *
 * Strategia:
 * - 2+ viewed (z wykluczeniem current PDP) → use viewed[0..1]
 * - 1 viewed → mix viewed[0] + first bestseller (excluding viewed[0] + current)
 * - 0 viewed → DO NOTHING (SSR zostaje)
 *
 * Source of truth bestsellery fallback: <script id="ms-bestsellers-fallback">
 * Source of truth current PDP: parsowany z URL
 * =================================================================== */

(function () {
  'use strict';

  // 1. Helpers
  function getCurrentHandle() {
    const m = location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function getViewedHandles() {
    try {
      const raw = localStorage.getItem('ms_recently_viewed');
      if (!raw) return [];
      const arr = JSON.parse(raw);
      return Array.isArray(arr) ? arr.filter(Boolean) : [];
    } catch (e) {
      return [];
    }
  }

  function getBestsellersFallback() {
    try {
      const el = document.getElementById('ms-bestsellers-fallback');
      if (!el) return [];
      return JSON.parse(el.textContent.trim()) || [];
    } catch (e) {
      return [];
    }
  }

  function formatPrice(cents) {
    const value = (cents / 100).toFixed(2).replace('.', ',');
    return value + ' zł';
  }

  async function fetchProduct(handle) {
    try {
      const r = await fetch('/products/' + handle + '.js');
      if (!r.ok) return null;
      const p = await r.json();
      if (!p.available) return null;
      return p;
    } catch (e) {
      return null;
    }
  }

  // 2. Card builders (klasy muszą matchować SSR markup z prompt 19A)

  function buildMenuCard(p) {
    const compareHtml = (p.compare_at_price && p.compare_at_price > p.price)
      ? '<p class="compare-at">' + formatPrice(p.compare_at_price) + '</p>'
      : '';
    const imgUrl = p.featured_image
      ? p.featured_image.replace(/(\.[a-z]{3,4})(\?|$)/i, '_240x$1$2')
      : '';
    const imgHtml = imgUrl
      ? '<img src="' + imgUrl + '" alt="' + escapeHtml(p.title) + '" loading="lazy" width="120" height="160">'
      : '';

    return [
      '<a href="', p.url, '" class="ms-menu-editorial-card" data-handle="', p.handle, '">',
      '<div class="img-wrap">', imgHtml, '</div>',
      '<p class="name">', escapeHtml(p.title), '</p>',
      '<div class="price-row">',
      '<p class="price">', formatPrice(p.price), '</p>',
      compareHtml,
      '</div>',
      '</a>'
    ].join('');
  }

  function buildCartCard(p) {
    const compareHtml = (p.compare_at_price && p.compare_at_price > p.price)
      ? '<s>' + formatPrice(p.compare_at_price) + '</s>'
      : '';
    const imgUrl = p.featured_image
      ? p.featured_image.replace(/(\.[a-z]{3,4})(\?|$)/i, '_400x$1$2')
      : '';
    const imgHtml = imgUrl
      ? '<img src="' + imgUrl + '" alt="' + escapeHtml(p.title) + '" loading="lazy" width="200" height="200">'
      : '';

    return [
      '<a href="', p.url, '" class="cro-cart-rec-item" data-handle="', p.handle, '">',
      '<div class="cro-cart-rec-img">', imgHtml, '</div>',
      '<p class="cro-cart-rec-title">', escapeHtml(p.title), '</p>',
      '<p class="cro-cart-rec-price">',
      '<span>', formatPrice(p.price), '</span>',
      compareHtml,
      '</p>',
      '</a>'
    ].join('');
  }

  function escapeHtml(str) {
    const div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
  }

  // 3. Main hydration

  async function hydrateRecommendations() {
    const menuGrid = document.querySelector('.ms-menu-editorial-grid[data-ms-recs="menu"]');
    const cartGrid = document.querySelector('.cro-cart-rec-grid[data-ms-recs="cart"]');

    if (!menuGrid && !cartGrid) return;

    const current = getCurrentHandle();
    const viewed = getViewedHandles().filter(h => h !== current);
    const bestsellers = getBestsellersFallback().filter(h => h !== current);

    let pickedHandles = [];
    if (viewed.length >= 2) {
      pickedHandles = [viewed[0], viewed[1]];
    } else if (viewed.length === 1) {
      const fallback = bestsellers.find(h => h !== viewed[0]);
      if (fallback) pickedHandles = [viewed[0], fallback];
      else return;
    } else {
      return;
    }

    const products = await Promise.all(pickedHandles.map(fetchProduct));
    const valid = products.filter(Boolean);

    if (valid.length < 2) return;

    if (menuGrid) {
      menuGrid.innerHTML = valid.map(buildMenuCard).join('');
    }
    if (cartGrid) {
      cartGrid.innerHTML = valid.map(buildCartCard).join('');
    }
  }

  // 4. Trigger

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hydrateRecommendations);
  } else {
    hydrateRecommendations();
  }
})();
